import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

/**
 * Redirects PLAYER role users from /home to their own player profile.
 * Non-PLAYER roles pass through unaffected.
 */
export const playerRedirectGuard: CanActivateFn = () => {
  const authService = inject(AuthService)
  const router = inject(Router)

  const route = authService.getPlayerProfileRoute()
  if (route) {
    return router.createUrlTree(route)
  }

  return true
}
